import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useSelector } from "react-redux";
import OnboardLayout from "../components/layouts/OnboardLayout/OnboardLayout";
import AuthLayout from "../components/layouts/AuthLayout/AuthLayout";
import { ROUTES } from "../routes";
import { useLocation } from "react-router-dom";

const NoGuard = () => {
  const isUserLoggedin = useSelector((state) => state?.persist?.isUserLoggedin);
  const location = useLocation();
  let isAuthenticated = isUserLoggedin;

  // Allow access to /unsubscribe explicitly
  if (location.pathname === ROUTES.UNSUBSCRIBE) {
    return (
      <OnboardLayout>
        <Outlet />
      </OnboardLayout>
    );
  }

  // Redirect authenticated users to their default dashboard
  if (isAuthenticated) {
    return (
      <AuthLayout>
        <Navigate to={ROUTES.BUY} />
      </AuthLayout>
    );
  }

  // Allow unauthenticated users to access onboarding pages
  return (
    <OnboardLayout>
      <Outlet />
    </OnboardLayout>
  );
};

export default NoGuard;
